import { getRequest } from '../services/requestHandler';
import { AppMenu } from '../models';

export const getAppMenus = async () => {
  const url = 'app/GetAppMenus?activeOnly=true&useCache=true';
  const response = await getRequest<AppMenu>('GetAppMenus', url);
  return response;
};
